import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingCall } from "@/components/FloatingCall";
import Home from "@/pages/Home";
import CityPage from "@/pages/CityPage";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
        };
    }, []);

    return (
        <HelmetProvider>
            <BrowserRouter>
                <ScrollToTop />
                <div className="min-h-screen bg-white text-[#141721] antialiased">
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/cash-for-cars/:slug" element={<CityPage />} />
                    </Routes>
                    <Footer />
                    <FloatingCall />
                </div>
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;
